<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Title:" v-model="tempTitle" />
      </div>
      <div class="vx-col w-full mb-base">
        <vs-textarea class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Description:" v-model="tempDescription" />
      </div>
      <div class="vx-col w-full mb-base">
        <vs-checkbox success v-model="hideSpaceFromSidebar">
          Hide space from sidebar
        </vs-checkbox>
      </div>
      <div class="vx-col w-full mb-base">
        <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Subscription ID:" v-model="tempSubscriptionId" />
      </div>
      <div class="vx-col w-full mb-base">
        <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Payment Link" v-model="tempPaymentLink" />
      </div>
      <div class="vx-col w-full mb-base">
        <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Certificate Title" v-model="tempCertificateTitle" />
      </div>
      <div class="vx-col w-full mb-base">
        <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Certificate Icon Path" v-model="tempCertificateIcon" />
        <input type="file" @change="uploadCertificateIcon($event)" accept="image/*" style="margin-top: 8px;" />
      </div>
      <div class="vx-col w-full mb-base">
        <vs-textarea class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Certificate Description" v-model="tempCertificateDescription" />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vs-button @click="EditSpace()">Save changes</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  export default {
    data() {
      return {
        tempTitle: this.space.title,
        tempDescription: this.space.description,
        tempSubscriptionId: this.space.subscriptionId,
        tempPaymentLink: this.space.paymentLink,
        hideSpaceFromSidebar: this.space.hideFromSidebar,
        tempCertificateTitle: this.space.certificateTitle,
        tempCertificateIcon: this.space.certificateIcon,
        tempCertificateDescription: this.space.certificateDescription,
      }
    },
    props: ["space"],
    methods: {
      EditSpace() {
        var instance = this
        const spaceVariables = {
          id: instance.space.id,
          title: instance.tempTitle,
          description: instance.tempDescription,
          icon: "",
          urlName: "",
          hideFromSidebar: instance.hideSpaceFromSidebar,
          rootId: instance.space.rootId,
          parentId: instance.space.parentId,
          subscriptionId: instance.tempSubscriptionId,
          paymentLink: instance.tempPaymentLink,
          certificateTitle: instance.tempCertificateTitle,
          certificateIcon: instance.tempCertificateIcon,
          certificateDescription: instance.tempCertificateDescription
        }
        const query = `
mutation AddSpace($space: SpaceInput!) {
  addSpace(entity: $space) {
    id,
    title,
    description,
    icon,
    urlName,
    hideFromSidebar,
    rootId,
    parentId,
    subscriptionId,
    paymentLink,
    certificateTitle,
    certificateIcon,
    certificateDescription
    }
 }
`;
        const variables = {
          space: spaceVariables
        }

        const req = {
          query,
          variables
        };
        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data.data) {

            instance.$vs.notify({
              title: "Success!",
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors saving :( ');
            console.error("ERROR SAVING SAVE: ", response.data);
          }
        });
      },
      async uploadCertificateIcon(event) {
        const file = event.target.files[0];
        if (!file) return;
        const formData = new FormData();
        formData.append('file', file);
        try {
          const response = await TCVelikClient.PostRelative('/api/upload/certificate-icon', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          });
          if (response && response.data && response.data.relativeUrl) {
            this.tempCertificateIcon = response.data.relativeUrl;
            this.$vs.notify({
              title: 'Success!',
              text: 'Icon uploaded.',
              color: 'success',
              iconPack: 'feather',
              position: 'top-center',
              icon: 'icon-check-circle',
            });
          } else {
            throw new Error('No relativeUrl returned');
          }
        } catch (e) {
          this.$vs.notify({
            title: 'Error!',
            text: 'Failed to upload icon.',
            color: 'danger',
            iconPack: 'feather',
            position: 'top-center',
            icon: 'icon-alert-circle',
          });
        }
      },
    },
    watch: {
      space: {
        handler(newSpace) {
          this.tempTitle = newSpace.title;
          this.tempDescription = newSpace.description;
          this.tempSubscriptionId = newSpace.subscriptionId;
          this.tempPaymentLink = newSpace.paymentLink;
          this.hideSpaceFromSidebar = newSpace.hideFromSidebar;
          this.tempCertificateTitle = newSpace.certificateTitle;
          this.tempCertificateIcon = newSpace.certificateIcon;
          this.tempCertificateDescription = newSpace.certificateDescription;
        },
        immediate: true,
        deep: true
      }
    }
  }
</script>
